// extracted by css-extract-rspack-plugin
export default {"opportunityLink":"TimeLogsTable_opportunityLink__kdklZ"};